import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type BookLibraryCollectionService from 'teacher-ui-client/services/book-library/collection'
import type ReadingScalesService from 'teacher-ui-client/services/reading-scales'

export default class BookLibrarySearchRoute extends Route {
  @service('book-library/collection') collectionService!: BookLibraryCollectionService

  @service readingScales!: ReadingScalesService

  model() {
    return {
      loadPrimaryFilters: this.readingScales.allPrimaryFilters.perform(),
      loadCollections: this.collectionService.loadAllMyCollections.perform(),
    }
  }
}
